import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import PaymentsPaid from '../components/PaymentsPaid'
import { actionCreators } from '../actions'
import { getRefundContext } from '../utils'

const mapStateToProps = (state) => {
  const paymentsPaid = state.order.paymentsPaid

  if (!paymentsPaid) {
    return {
      paymentsPaid: [],
    }
  }

  const paymentsPaidProps = {
    paymentsPaid: paymentsPaid.map((paymentPaid) => ({
      ...paymentPaid,
      refund: getRefundContext(paymentPaid),
    })),
  }

  return paymentsPaidProps
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsPaid)
